import { ChangeDetectorRef, Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { SETTINGS_PATH } from "@bitwarden/web-vault/app/models/constants/global.constants";

@Component({
  selector: "app-settings-route",
  templateUrl: "settings-route.component.html",
})
export class SettingsRouteComponent {
  protected title = "";
  protected previousRoute = SETTINGS_PATH;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {}

  onActivate() {
    this.title = this.route.snapshot.firstChild?.data["titleId"];
    const parentRoutePath = this.route.snapshot.parent?.routeConfig?.path;
    if (parentRoutePath) {
      this.previousRoute = `/${parentRoutePath}`;
    }
    this.cdr.detectChanges();
  }
}
